import React, { useRef, useState, useEffect, useMemo } from "react";
import {
  Plane,
  Vector3,
  Matrix4,
  BufferGeometry,
  LineBasicMaterial,
  LineSegments,
  TextureLoader,
  RepeatWrapping,
} from "three";

import {
  setLeftPosState,
  setRightPosState,
} from "../../features/drawing/drwingSlice.js";
import { useDispatch, useSelector } from "react-redux";
import { useDrawing } from "../../hooks/useDrawing.js";
import usePoints from "../../hooks/usePoints.js";
import { resetShowFirstTimePopup, setShowFirstTimePopup } from "../../Actions/PopupAction.js";
import scale from "../../assets/scale.png"
import { Html } from "@react-three/drei";
import ScalePopup from "../Overlays/ScalePopup.js";

export const Scale = () => {
  const dispatch = useDispatch();
  const mesh = useRef();
  const leftJaw = useRef();
  const rightJaw = useRef();
  const [dragging, setDragging] = useState(null);
  const [dimensions, setDimensions] = useState({ l: 100, w: 15, h: 0 });
  const [isDraggingBox, setIsDraggingBox] = useState(false);
  const [position, setPosition] = useState(new Vector3(0, 0, 0));
  const [lineAngle, setLineAngle] = useState(0);
  const [isPointerMoving, setIsPointerMoving] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const { leftPos, rightPos, userLength } = useSelector((state) => state.drawing);
  const [leftJawActivated, setLeftJawActivated] = useState(false);
  const [rightJawActivated, setRightJawActivated] = useState(false);
  const tolerance = 1e-3;
  const { screenToNDC} = usePoints();
  const { showFirstTimePopup, firstTimePopupNumber, enableFirstTimePopup } =useSelector((state) => state.PopupState);

  
  

  return (
    <>
      <ScalePopup position={position} type={"canvas"} />
    </>
  );
};
